import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Helmet } from "react-helmet";

import Btn from '../../Components/Btn';
import Alert from '../../Components/Alert';
import { bindActionCreators } from 'redux';
import { forgotPassword } from '../../store/user/actions';
import LoadingOverlay from 'react-loading-overlay';
import { loaderstyle } from '../../config';

class ForgotPassword extends Component {
  state = {
    forgot_email: ''
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  getAlertMessage = (success, error) => {
    if (!success && !error) return undefined;

    if (error) {
      return error;
    }

    if (success) {
      return "Please check your email to reset password"
    }
  }


  /**
   * @param {Event} e
   */
  forgotPassword = (e) => {
    e.preventDefault();

    this.props.forgotPassword(this.state.forgot_email);
  }

  render() {
    const { loading, error, success } = this.props.user.forgotPassword;
    const msg = this.getAlertMessage(success, error);
    const color = error? "red": "green";

    return (
      <div className="login-page">
        <Helmet>
          <title>Forgot Password | Go Bus Dashboard</title>
        </Helmet>
        <div className="login-widget">
          <div className="login-widget-head">
            <img src="/imgs/logo-border.png" alt="Go Bus Logo" />
            <h1>Go Bus Dashboard</h1>
          </div>
          <div className="login-widget-content">

            <Alert
              msg={msg}
              color={color}
              subline={this.state.forgot_email} />

            <LoadingOverlay
              active={loading}
              // text=""
              spinner
              styles={loaderstyle}
            >
              <form onSubmit={this.forgotPassword}>
                {!success && (
                  <>
                    <h3>Enter your email to reset password</h3>
                    <div className="form-field">
                      <h5 className="label">Email Address</h5>
                      <input name="forgot_email" type="email" onChange={this.handleChange} value={this.state.forgot_email} />
                    </div>
                    <Btn className="btn submit full">Send Reset Email</Btn>
                  </>
                )}

                {success && (
                  <>
                    <p className="extra-txt">Didn’t receive it?</p>
                    <Btn className="btn submit small">Send Again</Btn>
                  </>
                )}
              </form>
            </LoadingOverlay>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  forgotPassword: bindActionCreators(forgotPassword, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)
